import { FormattedMessage } from 'react-intl';
import { QuoteFormErrorMessage } from 'routes/essential-workspace/components/quote-panel/quote/form-error-message';

export function NotReadyQuoteDetails() {
  return (
    <div className="flex-y py-0 align-items-center justify-content-center text-secondary gap-1 text-center quote-details-min-height">
      <i className="icon icon-lg">tune</i>
      <h4>
        <FormattedMessage id="sidePanel.quoteStatus.notReady.configure" defaultMessage="Not Ready" />
      </h4>
      <span>
        <QuoteFormErrorMessage multiple />
      </span>
    </div>
  );
}
